import React, { useState, useEffect } from "react";
import BreadCrumb from "../../BreadCrumb";
import Layout from "../../Layout";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../../common/Loader";
import DataTable from "../../Tables/DataTable";
import { downloadInvoice } from "../../../redux/actions/paymentAction";
import PaymentDetails from "../../PaymentsLIst/PaymentDetails";
import { STUDENT } from "../../../common/constants";
import { studentPaymentHistoryAction, updateChequeDetailsAction } from "../../../redux/actions/studentActions";
import UpdateChequeDetails from "../../PaymentsLIst/updateChequeDetails";
import AgGridTable from "../../Tables/agGridTable";
import { APPORVED, CHEQUE, PAYMENT_COMPLETED,PARTIAL_PAYMENT,SETTLE_STUDENT,PAYMENT_PENDING,PAYMENT_FAILED,INITIATE_PAYMENT } from "../../constants";


const StudentPaymentHistory = (props) => {
  const dispatch = useDispatch();
  const { userDetails  } = useSelector((state) => state.user);
  const { loader, studentPaymentHistoryData  } = useSelector((state) => state.student);
  const [show, setShow] = useState(false);
  const [chequeShow, setChequeShow] = useState(false);
  const [sideMenu, setSideMenu] = useState(true);
  const [selectedTransaction, setSelectedTransaction] = useState({})
  const [agGridRef, setAgGridRef] = useState(null);
  const [rowNode, setRowNode] = useState(null);
  
  useEffect(async() => {
    if(userDetails.role === STUDENT){
      await dispatch(studentPaymentHistoryAction({StudentId: userDetails.StudentId}))
    }
  }, []);
  const onSideMenu = (value) => {
    setSideMenu(value);
  };
  

  const downloadPaymentReceipt = async(data)=>{
    await dispatch(downloadInvoice({OrderId: data.ORDER_ID}))
  }
  const paymentDetails = async(data)=>{
    setSelectedTransaction(data);
    setShow(true)
  }
  const updateChequeDetails = async(data,rowNodeRef)=>{
    console.log(data)
    setSelectedTransaction(data);
    setChequeShow(true)
    // setRowNode(rowNodeRef)
  }
  const actionsStudentListComponent = props => {
    console.log(props)
    return (
      <>
          {
            props.data ? (
              <>
              <div className='row'>
                <div className="col-6">
                <i class={"fa fa fa-download"}  aria-hidden="true" title="Download Receipt" style={{
                    alignItems: "center",
                    color: "#1c5983",
                    cursor: 'pointer',
                    fontSize:"18px"
                    
                  }} onClick={()=>{
                    props.downloadPaymentReceipt(props.data);
                  }}></i>  
                </div>
                <div className="col-6">
                <i class={"fa fa-angle-right"}  aria-hidden="true" title="Payment Details" style={{
                    alignItems: "center",
                    color: "#1c5983",
                    cursor: 'pointer',
                    fontSize:"18px"
                    
                  }} onClick={()=>{
                    props.paymentDetails(props.data);
                  }}></i>  
                </div>
            </div>
        </>
        ) : null }
          
         
        
      </>
    )  
  };
  const actionsAdminListComponent = props => {
    console.log(props)
    return (
      <>
          {
            props.data ? (
              <>
              <div className='row'>
              <div className="col-6">

                {
                  props.data.paymentStatus === 'Payment Completed' ? (
                      <i class={"fa  fa-download"}  aria-hidden="true" title="Download Receipt" style={{
                          alignItems: "center",
                          color: "#1c5983",
                          cursor: 'pointer',
                          fontSize:"18px"
                          
                        }} onClick={()=>{
                          props.downloadPaymentReceipt(props.data);
                        }}></i>  
                  ) : null
                 }
                 {
                  props.data.paymentStatus === 'Payment Pending' && props.data.payMode === CHEQUE ? (
                      <i class={"fa  fa-check-circle"}  aria-hidden="true" title="Update Cheque Detail" style={{
                          alignItems: "center",
                          color: "#1c5983",
                          cursor: 'pointer',
                          fontSize:"18px"
                          
                        }} onClick={()=>{
                          // const rowNodeObj = props.agGridRef.current.api.getRowNode(String(props.data.id));
                          props.updateChequeDetails(props.data,{});
                        }}></i>  
                  ) : null
                 }
                </div>

                
                <div className="col-6">
                <i class={"fa fa-angle-right"}  aria-hidden="true" title="Payment Details" style={{
                    alignItems: "center",
                    color: "#1c5983",
                    cursor: 'pointer',
                    fontSize:"18px"
                    
                  }} onClick={()=>{
                    props.paymentDetails(props.data);
                  }}></i>  
                </div>
            </div>
        </>
        ) : null }
          
         
        
      </>
    )  
  };
  const studentHeaderList = [
    { headerName: "ClassGroup Name", field: "classGroupName" },
    { headerName: "Order Id", field: "ORDER_ID",minWidth:265 },
    { headerName: "Amount Paid", field: "amount" },
    { headerName: "Payment Mode", field: "payMode" },
    { headerName: "Payment Status", field: "paymentStatus",
    cellStyle: params => {
      if (params.value === PAYMENT_COMPLETED) {
        return { backgroundColor: '#ddeec4'};
    }
    if (params.value === PAYMENT_FAILED) {
      return { backgroundColor: '#f3c0bf'};
    }
    if (params.value === INITIATE_PAYMENT) {
      return { backgroundColor: '#fddfbd'};
    }

      return null;
    }},
    { headerName: "Created At", field: "createdAt", },
    {
      headerName: "Action",
      field: "action",
      cellRenderer: "actionsStudentListComponent",
      cellRendererParams: {
        downloadPaymentReceipt,
        paymentDetails
      },
    },
    // {
    //   headerName: "Action",
    //   key: "action",
    //   requiredActions: [
    //     {
    //       actionKey: "Download Receipt",
    //       icon: "fa fa-download",
    //       handleAction: downloadPaymentReceipt,
    //     },
    //     {
    //       actionKey: "Payment Details",
    //       icon: "fa fa-angle-right",
    //       handleAction: paymentDetails,
    //     }
    //   ],
    // },
    
  ];
  const adminHeaderList = [
    { headerName: "ClassGroup Name", field: "classGroupName" },
    { headerName: "Order Id", field: "ORDER_ID",minWidth:265 },
    { headerName: "Amount Paid", field: "amount" },
    { headerName: "Payment Mode", field: "payMode" },
    { headerName: "Payment Status", field: "paymentStatus",
    cellStyle: params => {
      console.log(params)
      if (params.value === PAYMENT_COMPLETED) {
          return { backgroundColor: '#ddeec4'};
      }
      if (params.value === PAYMENT_FAILED) {
        return { backgroundColor: '#f3c0bf'};
      }
      if (params.value === INITIATE_PAYMENT) {
        return { backgroundColor: '#fddfbd'};
      }
      

      return null;
    } },
    { headerName: "Created At", field: "createdAt" },

    {
      headerName: "Action",
      field: "action",
      cellRenderer: "actionsAdminListComponent",
      cellRendererParams: {
        downloadPaymentReceipt,
        paymentDetails,
        updateChequeDetails
      },
    },
    
  ];
  const closeModal =()=>{
    setShow(false)
    setChequeShow(false)
  }

  const updateChequeInfo = async(data)=>{
    console.log(selectedTransaction,data)
    const reqParams = {
      ...data,
      PaymentId: selectedTransaction.id,
      ChequeTransactionId: selectedTransaction.ChequeTransaction.id
    }
   await dispatch(updateChequeDetailsAction(reqParams,studentPaymentHistoryData));
  //  let updateObj = { ...rowNode.data}
  //   if(reqParams.chequeStatus === APPORVED){
  //     updateObj.paymentStatus = "Payment Completed"
  //   }else{
  //     updateObj.paymentStatus = "Payment Failed"
  //   }
  //  rowNode.setData({...updateObj});
   setChequeShow(false)
  }

  const setGridRefData =(params)=>{
    setAgGridRef(params)
  }
  return (
    <>
    {
      userDetails.role === STUDENT ? (
        <>
        <div className="page-wrapper">
            <Layout onClick={onSideMenu} />
            <PageLoader loader={loader}>
              <div
                className={`main-content d-flex flex-column ${
                  sideMenu ? "" : "hide-sidemenu"
                }`}
              >
                <div className="main-content-header">
                  <BreadCrumb />
                </div>
                <div className="spacer"></div>
                  { show  && Object.keys(selectedTransaction).length > 0 ?  (
                    <PaymentDetails show={show} data={selectedTransaction.paymentInfo} closeModal={closeModal}/>
                  ) : null }
                  {studentPaymentHistoryData.length > 0 ? (
                    <>
                    {/* <DataTable
                      header={studentHeaderList}
                      data={studentPaymentHistoryData}
                      // nestedHeader={nestedHeaders}
                    /> */}
                    <AgGridTable 
                    rowData={studentPaymentHistoryData} 
                    columnDefs={studentHeaderList} 
                    defaultColDef={{
                      resizable: true,minWidth: 100}}
                      frameworkComponents={{
                        actionsStudentListComponent
                    }}
                      />
                    </>
                  ) : (
                    <div className="alert alert-success">No Data to view</div>
                  )}
              </div>
            </PageLoader>
          </div>
        </>
      ): (
        <>
        <div className="page-wrapper">
          <div className="spacer"></div>
          { show  && Object.keys(selectedTransaction).length > 0 ?  (
            <PaymentDetails show={show} data={selectedTransaction.paymentInfo} closeModal={closeModal}/>
          ) : null }
          { chequeShow  && Object.keys(selectedTransaction).length > 0 ?  (
            <UpdateChequeDetails show={chequeShow} data={selectedTransaction.paymentInfo} closeModal={closeModal} update={updateChequeInfo}/>
          ) : null }
          {studentPaymentHistoryData.length > 0 ? (
            <>
            {/* <DataTable
              header={adminHeaderList}
              data={studentPaymentHistoryData}
              // nestedHeader={nestedHeaders}
            /> */}
            <AgGridTable 
                    rowData={studentPaymentHistoryData} 
                    columnDefs={adminHeaderList} 
                    defaultColDef={{
                      resizable: true,minWidth: 100}}
                      frameworkComponents={{
                        actionsAdminListComponent
                    }}
                      />
            </>
          ) : (
            <div className="alert alert-success">No Data to view</div>
          )}
       
    </div>
        </>
      )
    }
    </>
     
  );
};

export default StudentPaymentHistory;
